import { createContext, useContext } from 'react';

const WorkspaceContext = createContext<any>(undefined);

export const useWorkspaceContext = () => useContext(WorkspaceContext);
export default WorkspaceContext;
